// ----------------------------------------------------------------------

// In dark, floating surfaces step one up from the paper they open over (Base:
// surfaces stack upwards). On the same grey 800 as a dialog, a dropdown inside
// it had nothing but a faint shadow to set it apart.
export const floatingSurface = (theme) =>
    theme.palette.mode === 'dark'
        ? theme.palette.background.neutral
        : theme.palette.background.paper;

export default function Popover(theme) {
    const menuItem = {
        borderRadius: theme.shape.menuItem,
    };

    return {
        // Popovers and menus float above the page: the dropdown shadow and
        // the popover radius. Items inside a padded popover get their own
        // rounded hover shape.
        MuiPopover: {
            styleOverrides: {
                paper: {
                    'backgroundColor': floatingSurface(theme),
                    'boxShadow': theme.customShadows.dropdown,
                    'borderRadius': theme.shape.popover,
                    '& .MuiMenuItem-root': menuItem,
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                list: {
                    padding: theme.spacing(0.5),
                },
            },
        },
    };
}
